export default __webpack_public_path__ + "static/media/icon-dir.eebdfb3f.svg";